import { RECAPTCHA_SITE_KEY } from "@/security/terms.catalog";

// Carga y ejecuta Google reCAPTCHA v3 bajo demanda. El token resultante se envía en el
// clientMetadata del signUp y lo valida el lambda pre-sign-up.

type Grecaptcha = {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, opts: { action: string }) => Promise<string>;
};

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

let scriptPromise: Promise<void> | null = null;

const loadScript = (): Promise<void> => {
  if (window.grecaptcha) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("No fue posible cargar reCAPTCHA"));
    document.head.appendChild(script);
  });
  return scriptPromise;
};

/**
 * Devuelve un token de reCAPTCHA v3 para la acción indicada, o undefined si no hay site key
 * configurada (en ese caso el pre-sign-up permite el registro).
 */
export const getRecaptchaToken = async (action = "register"): Promise<string | undefined> => {
  if (!RECAPTCHA_SITE_KEY) return undefined;
  try {
    await loadScript();
    const grecaptcha = window.grecaptcha;
    if (!grecaptcha) return undefined;
    return await new Promise<string>((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(RECAPTCHA_SITE_KEY, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  } catch (err) {
    console.error("[recaptcha] error obteniendo token", err);
    return undefined;
  }
};
